<form #clientGuestForm="ngForm" style="margin: auto;" [ngFormOptions]="{updateOn:'change'}" >
  <div  class="guest-client-override" lang="{{translate.currentLang}}"> </div>
  <div class="tw-flex tw-row-2" style="justify-content: center">
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
      <mat-label>{{'client.firstName' | translate}}</mat-label>
      <input type="email" matInput placeholder=""
        ngModel required name="firstname" #firstname="ngModel">
      <mat-error>
        <tw-form-error-message [errors]="firstname.errors"></tw-form-error-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
      <mat-label>{{'client.lastName' | translate}}</mat-label>
      <input type="email" matInput placeholder=""
        ngModel required name="lastname" #lastname="ngModel">
      <mat-error>
        <tw-form-error-message [errors]="lastname.errors"></tw-form-error-message>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="tw-flex tw-row-2" style="justify-content: center">
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
      <mat-label>{{'client.email' | translate}}</mat-label>
      <input type="email" matInput placeholder=""
        ngModel required name="email" #email="ngModel" autocomplete='email' twValidateEmail >
      <mat-error>
        <tw-form-error-message [errors]="email.errors"></tw-form-error-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
      <mat-label>{{'client.emailConfirmation' | translate}}</mat-label>
      <input type="email" matInput placeholder=""
        ngModel required name="emailConfirmation" #emailConfirmation="ngModel" autocomplete='email'

        twEqualValidator="email"
        twValidateEmail (paste)="$event.preventDefault()"  >
      <mat-error>
        <tw-form-error-message [errors]="emailConfirmation.errors"></tw-form-error-message>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-row-reverse">

    <button mat-raised-button color="primary"  class="tw-primary" (click)="next()" >
      <!--            {{ "title.next" | translate }}-->
      @if (!isFree) {
        <span>{{ "title.next" | translate }}</span>
      }
      @if (isFree) {
        <span>{{ "formMsg.reserve" | translate }}</span>
      }
    </button>
  </div>

</form>
